export default "__VITE_ASSET__DNLbwEXm__"